<template>
  <div>
    <loader :loading="reportLoading"></loader>
    <div class="row">
      <div class="col">
        <card>
          <label :for="`${_uid}-reports-options`"><h3 class="card-title">Reports</h3></label>
          <div class="row">
            <div class="col-lg-4">
              <validation-observer ref="observer">
                <validation-provider rules="requiredReport" v-slot="{ errors }">
                  <el-select
                    :id="`${_uid}-reports-options`"
                    class="select-primary w-100"
                    size="large"
                    placeholder="Select Report"
                    v-model="selectedReport">
                    <el-option
                      v-for="option in reports"
                      class="select-primary"
                      :value="option.value"
                      :label="option.label"
                      :key="option.label">
                    </el-option>
                  </el-select>
                  <h6 v-if="displayError(errors, 'element id -- ' + `${_uid}-reports-options`)" class="text-danger mt-2">{{ errors[0] }}</h6>
                </validation-provider>
              </validation-observer>
            </div>
            <div class="col-lg-6">
              <base-button type="primary" @click="onRunReport" class="mt-0">Run Report</base-button>
            </div>
          </div>
        </card>
      </div>
    </div>
    <div v-if="hasData">
      <div class="row">
        <div class="col"><h4>{{ selectedReportTitle }}</h4></div>
      </div>
      <div class="row">
        <div class="col"><h5>Report Date: {{ currentDateTime }}</h5></div>
      </div>
      <div v-if="showFormatOptions">
        <div class="row">
          <div class="col">
            <el-tooltip
              content="View in HTML Format"
              effect="light"
              :open-delay="300"
              placement="top">
              <base-button type="primary" @click="onHtml" :disabled="htmlToggled">HTML</base-button>
            </el-tooltip>
            <el-tooltip
              content="View in Text Format"
              effect="light"
              :open-delay="300"
              placement="top">
              <base-button type="primary" @click="onText" :disabled="textToggled">Text</base-button>
            </el-tooltip>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <ag-grid-vue
              id="myGrid"
              style="width: 100%; height: 500px;"
              class="ag-theme-alpine"
              :gridOptions="gridOptions"
              :columnDefs="columnDefs"
              :rowData="rowData"></ag-grid-vue>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col">
          <base-button type="primary" @click="onExport">Export to CSV</base-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Loader from 'src/pages/Survey/Loader';
  import { ValidationObserver, ValidationProvider } from 'vee-validate';
  import { Select, Option } from 'element-ui';
  import { AgGridVue } from 'ag-grid-vue';
  import * as reports from 'src/modules/surveyReports';
  import { DateTime } from 'luxon';

  export default {
    components: {
      Loader,
      ValidationObserver,
      ValidationProvider,
      [Option.name]: Option,
      [Select.name]: Select,
      AgGridVue,
    },
    data() {
      return {
        reportLoading: false,
        reportDate: null,
        gridOptions: {},
        columnDefsOptions: {},
        rowData: [],
        rowDataOrig: [],
        selectedReport: null,
        viewingReport: null,
        selectedReportTitle: null,
        reports: [
          { value: 'QCUR', label: 'Question Columns, User Rows' },
          { value: 'RP', label: 'Response Percentages' },
          { value: 'TR', label: 'Text Responses' }
        ],
        htmlToggled: false,
        textToggled: false,
        delayRefreshMs: 1,
      }
    },
    computed: {
      hasData() {
        return this.rowData.length > 0;
      },
      currentDateTime() {
        return this.reportDate.toLocaleString(DateTime.DATETIME_FULL_WITH_SECONDS);
      },
      hasHtmlKey() {
        let hasKey = "html" in this.columnDefsOptions;
        return hasKey;
      },
      hasTextKey() {
        let hasKey = "text" in this.columnDefsOptions;
        return hasKey;
      },
      showFormatOptions() {
        return this.hasHtmlKey && this.hasTextKey;
      },
      columnDefs() {
        let colDefs = this.hasHtmlKey && this.htmlToggled ? this.columnDefsOptions['html'] : 
          (this.hasTextKey ? this.columnDefsOptions['text'] : this.columnDefsOptions);

        return colDefs;
      },
      rowDataNoMarkup() {
        const _ = require('lodash');
        let localData = _.cloneDeep(this.rowDataOrig);
        return localData.map(x => {
          Object.keys(x).forEach(key => {
            x[key] = this.trimHtmlTags(x[key]);
          });
          return x;
        });
      },
    },
    methods: {
      displayError(error, description = "") {
        let display = error.length > 0 && error[0].length > 0;
        // console.log("In Reports.vue -- error:");
        // console.log(error);
        // console.log((description.length > 0 ? "for [" + description + "]: " : "") + "display = [" + display + "]");
        return display;
      },
      refreshReport(ms, gridApi) {
        if (!gridApi) {
          return;
        }

        setTimeout(() => {
          gridApi.setRowData(this.rowDataOrig);
        }, ms);
      },
      onRunReport() {
        const obs = this.$refs.observer;

        obs.validate().then((passed) => {
          if(passed) {
            this.runReport();
          }
        });
      },
      runReport() {
        this.reportLoading = true;

        let report = this.reports.find(report => report.value === this.selectedReport);
        let reportRequest = {
          surveyUrlId: this.$route.params.urlId,
          hspSurveyId: this.$route.params.surveyId
        }

        this.selectedReportTitle = report.label;
        this.reportDate = DateTime.now();

        if(report.value === 'QCUR') {
          reports.getQcurData(reportRequest)
            .then(data => {
              this.populateGrid(data);
            });
        }
        else if(report.value === 'RP') {
          reports.getRpData(reportRequest)
            .then(data => {
              this.populateGrid(data);
            });
        }
        else if(report.value === 'TR') {
          reports.getTrData(reportRequest)
            .then(data => {
              this.populateGrid(data);
            });
        }
      },
      populateGrid(data) {
        this.rowDataOrig = data.rowData;
        this.columnDefsOptions = data.columnDefs;
        this.rowData = data.rowData;
        this.reportLoading = false;
        this.viewingReport = this.selectedReport;

        if (!this.htmlToggled && !this.textToggled) {
          if (this.hasHtmlKey) {
            this.onHtml();
          }
          else {
            this.onText();
          }
        }
      },
      trimHtmlTags(value) {
        if (!value) return value;

        return value.toString().replace(/<[^<]+?>/gi, "");
      },
      onHtml() {
        if (!this.showFormatOptions) {
          return;
        }
        if (this.htmlToggled && !this.textToggled) {
          return;
        }
        this.textToggled = false;
        this.htmlToggled = !this.htmlToggled;
        this.refreshReport(this.delayRefreshMs, this.gridOptions.api);
      },
      onText() {
        if (!this.showFormatOptions) {
          return;
        }
        if (this.textToggled && !this.htmlToggled) {
          return;
        }
        this.htmlToggled = false;
        this.textToggled = !this.textToggled;
        this.refreshReport(this.delayRefreshMs, this.gridOptions.api);
      },
      onExport() {
        let filename = `${this.$route.params.urlId}_${this.viewingReport}_${this.reportDate.toFormat('ddMMMyyyy_HHmmss')}`.toUpperCase();

        if (this.htmlToggled) {
          // Since we're seeing formatted html text/data, the exported texts should not have any markups.
          this.gridOptions.api.setRowData(this.rowDataNoMarkup);
          this.gridOptions.api.exportDataAsCsv({
            fileName: filename
          });

          // Restore to original data format.
          this.gridOptions.api.setRowData(this.rowDataOrig);
        }
        else {
          this.gridOptions.api.exportDataAsCsv({
            fileName: filename
          });
        }
      },
    }
  }
</script>
<style lang="scss">
  @import "../../../node_modules/ag-grid-community/dist/styles/ag-grid.css";
  @import "../../../node_modules/ag-grid-community/dist/styles/ag-theme-alpine.css";
</style>